<div id="side-panel-container">
  <slot />
</div>

<style>
  #side-panel-container {
    flex-grow: 0;
    flex-shrink: 0;
    width: 300px;
    background-color: #f0f0f0;
    color: #808080;
    overflow-y: hidden;
    padding: 2rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
</style>
